
export function urlencode (params) {
    return Object
        .keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null)
        .map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
}

export function setDefaultSettings (xhr, appConfig) {
    xhr.timeout = appConfig.xhrTimeout;
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Cache-Control', 'no-store');
}
